import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { NDCCreditVoucherIssuanceLabels } from 'src/app/model/page/group/forms/ndc-credit-voucher-issuance/ndc-credit-voucher-issuance-page-labels';
import { NdcCreditVoucherIssuancePage } from 'src/app/model/page/group/forms/ndc-credit-voucher-issuance-page';
import { NdcCreditVoucherIssuace } from 'src/app/model/page/group/forms/ndc-credit-voucher-issuance-request';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-credit-voucher-issuance-page',
  templateUrl: './ndc-credit-voucher-issuance-page.component.html',
  styleUrls: ['./ndc-credit-voucher-issuance-page.component.scss']
})
export class NdcCreditVoucherIssuancePageComponent implements OnInit {
  ndcCreditVoucherIssuancePage: NdcCreditVoucherIssuancePage = {} as NdcCreditVoucherIssuancePage;
  ndcCreditVoucherIssueRequest: NdcCreditVoucherIssuace = {} as NdcCreditVoucherIssuace;
  CreditVoucherIssueLabels: NDCCreditVoucherIssuanceLabels = {} as NDCCreditVoucherIssuanceLabels;

  issueCreditVoucherForm: FormGroup = new FormGroup({
    contactName: new FormControl(''),
    contactEmail: new FormControl(''),
    agencyName: new FormControl(''),
    IATAnumber: new FormControl(''),
    airlinePNR: new FormControl(''),
    leadPassengerLastName: new FormControl(''),
    originalBookingDate: new FormControl(''),
    outboundTravelDate: new FormControl(''),
    phone: new FormControl(''),
    termsAndConditionsAgree: new FormControl(false)
  });

  submitted = false;
  phoneNumber = '';
  separateDialCode = false;
  issueVoucherSuccess = false;
  hideVocherForm = false;
  issueVocherFailedMsg = '';
  invalidOutboundDate = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  redirectUrlParsed: any;
  IsacceptConditions = true;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom, CountryISO.Spain, CountryISO.Germany, CountryISO.France, CountryISO.Russia];

  constructor(private contentfulService: ContentfulService, private formBuilder: FormBuilder, private datePipe: DateFormatPipe, private apiService: ApiService, private auth: entraAuthService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'issue-credit-vouchers') {
        this.ndcCreditVoucherIssuancePage.htmlTitle = title.htmlTitle;
      }
    });
    //this.auth.parseRedirectUrl();
    const query = { 'fields.title': 'NDC Credit Voucher Issuance' };
    this.ndcCreditVoucherIssuancePage.sections = [];
    this.contentfulService.getPageContentResponse(query).then((ndcCreditVoucherIssuancePageEntries) => {
      this.mapBanner(ndcCreditVoucherIssuancePageEntries.includes.Entry);
      this.mapSections(ndcCreditVoucherIssuancePageEntries.includes.Entry);
      this.mapHtmlTitle(ndcCreditVoucherIssuancePageEntries.items);
    });
    this.issueCreditVoucherForm = this.formBuilder.group({
      contactName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      contactEmail: ['', [Validators.required, Validators.email, Validators.minLength(2), Validators.maxLength(30)]],
      agencyName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]],

      airlinePNR: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(/^[a-zA-Z0-9]*$/)]],

      IATAnumber: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
      leadPassengerLastName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      phone: ['', [Validators.required]],
      originalBookingDate: ['', [Validators.required]],
      outboundTravelDate: ['', [Validators.required]],
      termsAndConditionsAgree: [false]
    });
    this.mapNDCVoucherIssueLabels();
    // console.log(this.ndcCreditVoucherIssuancePage);
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.ndcCreditVoucherIssuancePage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }

  private mapBanner(loginPageEntries: Entry<any>[]) {
    loginPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.ndcCreditVoucherIssuancePage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapSections(issueCreditVoucherPageEntries: Entry<any>[]) {
    issueCreditVoucherPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcCreditVoucherIssuancePage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.ndcCreditVoucherIssuancePage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  async sendCreditVoucherIssue(issueCreditVoucherForm: FormGroup) {
    this.submitted = true;
    if (issueCreditVoucherForm.value.termsAndConditionsAgree === false) {
      this.IsacceptConditions = false;
      return;
    }

    if (issueCreditVoucherForm.valid) {
      if (issueCreditVoucherForm.value.originalBookingDate <= issueCreditVoucherForm.value.outboundTravelDate) {
        this.invalidOutboundDate = false;
        this.ndcCreditVoucherIssueRequest.agencyContactDetails = {
          contactName: issueCreditVoucherForm.value.contactName,
          contactEmail: issueCreditVoucherForm.value.contactEmail,
          contactPhone: issueCreditVoucherForm.value.phone.e164Number,
          agencyDetails: {
            agencyName: issueCreditVoucherForm.value.agencyName,
            iataNumber: issueCreditVoucherForm.value.IATAnumber
          },
          bookingDetails: {
            pnr: issueCreditVoucherForm.value.airlinePNR,
            leadPassengerLastName: issueCreditVoucherForm.value.leadPassengerLastName,
            originalBookingDate: this.datePipe.transform(issueCreditVoucherForm.value.originalBookingDate, 'dd-MMM-yyyy'),
            outboundTravelDate: this.datePipe.transform(issueCreditVoucherForm.value.outboundTravelDate, 'dd-MMM-yyyy')
          }
        };

        const apiResponse = await this.apiService.sendPostRequest(this.ndcCreditVoucherIssueRequest.agencyContactDetails, '/voucher/issue');
        if (apiResponse.error) {
          if (apiResponse.error.error) {
            this.issueVocherFailedMsg = apiResponse.error.message ? apiResponse.error.message : apiResponse.error.error;
          }
          if (apiResponse.error.status == 401) {
            localStorage.setItem('redirect_url', '/forms/ndc-credit-voucher-issuance');
            this.auth.initLogin();
          }
          setTimeout(() => {
            this.issueVocherFailedMsg = '';
          }, 2000);
        } else {
          this.issueVoucherSuccess = true;
          this.submitted = false;
          this.issueCreditVoucherForm.reset();
          this.issueCreditVoucherForm.get('phone');
        }
      } else {
        this.invalidOutboundDate = true;
      }
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.issueCreditVoucherForm.controls;
  }

  getMaxOriginalBookingDate(): string {
    return new Date('2022-09-30').toISOString().split('T')[0];
  }

  getMaxOutboundTravelDate(): string {
    return new Date('2023-12-30').toISOString().split('T')[0];
  }

  private mapNDCVoucherIssueLabels() {
    // this.sideMenu.links = [];

    const query = { 'fields.title': 'NDC Credit Voucher Issuance' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      // console.log(labelItems[0]?.fields.constants);
      this.mapLables(labelItems[0]?.fields.constants);
    });
  }

  mapLables(labels: any) {
    this.CreditVoucherIssueLabels = {
      mainHeading: labels.mainHeading,
      agencyDeatailsHeading: labels.agencyDetails.heading,
      agencyName: labels.agencyDetails.agencyName,
      iata: labels.agencyDetails.iata,
      bookingDetailsHeading: labels.bookingDetails.heading,
      AirlinePNR: labels.bookingDetails.AirlinePNR,
      yourDetailsHeading: labels.yourDetails.heading,
      contactEmail: labels.yourDetails.contactEmail,
      contactName: labels.yourDetails.contactName,
      contactPhone: labels.yourDetails.contactPhone,
      invalidContactName: labels.errorMessages.invalidContactName,
      invalidEmail: labels.errorMessages.invalidEmail,
      invalidPhoneNumber: labels.errorMessages.invalidPhoneNumber,
      invalidAgencyName: labels.errorMessages.invalidAgencyName,
      invalidIATAnumber: labels.errorMessages.invalidIATAnumber
    };
  }
  // Only Integer Numbers
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  clearValidationMessage() {
    this.invalidOutboundDate = false;
  }
  clearCheckboxValidationMsg() {
    if (this.issueCreditVoucherForm.value.termsAndConditionsAgree === true) {
      this.IsacceptConditions = true;
    }
  }

  keyPressSpace(event: any) {
    var charCode = event.which ? event.which : event.keyCode;

    if (charCode === 32) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
